"use client";

import type { ChangeEventHandler } from "react";
import styles from "./Form.module.css";

/**
 * Honeypot — niewidoczne pole anti-spam.
 *
 * **Mechanizm:** boty fillują wszystkie inputy w formularzu. Honeypot jest
 * niewidoczny dla ludzi (`display:none` + offscreen position + tabindex=-1
 * + autocomplete=off) ale obecny w DOM. Backend sprawdza czy pole ma jakąś
 * wartość -> jeśli tak, request odrzucony jako bot.
 *
 * **Wielowarstwowe ukrycie:** część botów próbuje wykryć `display:none`
 * i pomija takie pola. Łącząc CSS `position:absolute; left:-9999px` +
 * `opacity:0` + `pointer-events:none` zwiększamy szansę że bot je wypełni.
 *
 * **A11y:** `aria-hidden="true"` na wrapperze + `tabindex=-1` na input żeby
 * nawigacja klawiaturą tabbingiem nie trafiła; screen reader też je pominie.
 */
export function Honeypot({ name, value, onChange }: HoneypotProps) {
  return (
    <div className={styles.honeypot} aria-hidden="true">
      <label htmlFor={name}>Nie wypełniaj tego pola</label>
      <input
        type="text"
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        tabIndex={-1}
        autoComplete="off"
      />
    </div>
  );
}

export type HoneypotProps = {
  /** Nazwa pola — pobierana z backend'u (`antispam.honeypot_field`). */
  name: string;
  /** Aktualna wartość (z React state — żeby bot manipulujący DOM nie ominął). */
  value: string;
  /** onChange handler. */
  onChange: ChangeEventHandler<HTMLInputElement>;
};
